"use client";

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from "react";
import { type Viewport, viewportStore } from "@/hooks/browser/viewport/viewport-breakpoint-store";
import { compareBreakpoints } from "@/utilities/ui/compare-breakpoints";
export function useViewportBreakpoint() {
  const $ = _c(14);
  const currentBreakpoint = useSyncExternalStore(viewportStore.subscribe, viewportStore.getSnapshot, viewportStore.getServerSnapshot);
  let t0;
  if ($[0] !== currentBreakpoint) {
    t0 = compareBreakpoints(currentBreakpoint, ">=", "3xl");
    $[0] = currentBreakpoint;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== currentBreakpoint) {
    t1 = compareBreakpoints(currentBreakpoint, ">=", "lg");
    $[2] = currentBreakpoint;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== currentBreakpoint) {
    t2 = compareBreakpoints(currentBreakpoint, "<", "lg");
    $[4] = currentBreakpoint;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== currentBreakpoint) {
    t3 = compareBreakpoints(currentBreakpoint, ">=", "md");
    $[6] = currentBreakpoint;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== currentBreakpoint || $[9] !== t0 || $[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = {
      currentBreakpoint,
      is3XlDesktop: t0,
      isDesktop: t1,
      isMobile: t2,
      isTablet: t3
    };
    $[8] = currentBreakpoint;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}